














































































































































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, PropSync, Watch, Prop } from 'vue-property-decorator';
import { PAYMENT_GATEWAYS, AcceptedPaymentGateway } from '@resclick/data-access';

@Component
export default class PaymentGatewaysModal extends Mixins(ModalMixin) {
  @PropSync('id', { type: String }) idSync!: string;
  @Prop() paymentOptionGroupId!: string;

  form!: CrsForm<'paymentGateways', 'create' | 'update'>;

  getInstitution(template: AcceptedPaymentGateway) {
    return PAYMENT_GATEWAYS[template].institution;
  }

  get templateOptions() {
    return (Object.keys(PAYMENT_GATEWAYS) as AcceptedPaymentGateway[]).map((value: AcceptedPaymentGateway) => {
      return {
        label: PAYMENT_GATEWAYS[value].prettyName,
        value,
      };
    });
  }

  get cardTypeMappingOptions() {
    return (Object.keys(PAYMENT_GATEWAYS) as AcceptedPaymentGateway[])
      .filter((key) => key !== this.form.fields.template)
      .map((value: AcceptedPaymentGateway) => {
        return {
          label: PAYMENT_GATEWAYS[value].prettyName,
          value,
        };
      });
  }

  @Watch('mode', { immediate: true })
  async switchForm(mode: 'create' | 'update') {
    const paymentOptionGroup = await compass.do('paymentOptionGroups', 'findById', {
      params: { paymentOptionGroupId: this.paymentOptionGroupId },
      select: ['company'],
    });

    this.form = this.$crsForm('paymentGateways', mode, {
      isActive: false,
      name: '',
      template: this.templateOptions[0].value,
      autoSelectMap: [],
      paymentOptionGroup: this.paymentOptionGroupId,
      company: paymentOptionGroup.data.company,

      apiCredentials: {
        // NESTPAY
        est_username: '',
        est_password: '',
        est_clientId: '',
        est_storeKey: '',
        est_section: '',

        // FINANS
        finans_mbrId: '',
        finans_merchantId: '',
        finans_merchantPass: '',
        finans_terminalID: '',
        finans_userCode: '',
        finans_userPass: '',

        // GARANTI
        garanti_terminalId: '',
        garanti_terminalMerchantId: '',
        garanti_provUserId: '',
        garanti_provPassword: '',
        garanti_secureKey: '',

        // YAPIKREDI
        // @ts-ignore
        yapikredi_mid: '',
        yapikredi_tid: '',
        yapikredi_posnetid: '',
        yapikredi_encKey: '',

        // VAKIFBANK
        // @ts-ignore
        vakifbank_MerchantId: '',
        vakifbank_MerchantPassword: '',
        vakifbank_TerminalNo: '',

        // DENIZBANK
        // @ts-ignore
        denizbank_ShopCode: '',
        denizbank_UserCode: '',
        denizbank_UserPass: '',
        denizbank_MerchantPass: '',

        // FASTPAY
        // @ts-ignore
        fastpay_MerchantId: '',
        fastpay_MerchantCode: '',
        fastpay_AppId: '',
        fastpay_AppSecret: '',
      },
    });
  }

  async getForm() {
    return compass.do('paymentGateways', 'findOne', { params: { paymentGatewayId: this.id } });
  }
}
